module.exports = __webpack_public_path__ + "static/media/eh.a4c42783.svg";